

export type PreLiquidationPaymentType = 'PB' | 'PN';

export enum PRELIQUIDATION_PAYMENT_TYPE {
    GROSS_AMOUNT = "PB",
    NET_AMOUNT = 'PN', // TODO: RECHEQUEAR ESTE..
}